export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/AU-f410303b095b7faecea2088dff0746ff.png";